export default "/assets/images/Home_Alexa_Google.d0996e18547ce754.mp4";